// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".history-section {\n  margin-top: 12rem; }\n", "",{"version":3,"sources":["webpack://src/scss/pages/error-boundary.scss"],"names":[],"mappings":"AAAA;EACI,iBAAiB,EAAA","sourcesContent":[".history-section {\n    margin-top: 12rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
